// 门店代收点物流接口
import axios from 'axios'

// 门店地址列表(分页)
export function getStageAddrOffline(data) {
  return axios({
    url: `/api/oms/stageAddr/listPage`,
    method: 'get',
    params: data
  })
}
// 门店地址列表(不分页)
export function getStageAddrAllOffline(data) {
  return axios({
    url: `/api/oms/stageAddr/list`,
    method: 'get',
    params: data
  })
}
// 门店地址删除
export function deleteStageOffline(id) {
  return axios({
    url: `/api/oms/stageAddr/delete?id=${id}`,
    method: 'get'
  })
}

// 门店地址新增
export function insertStageOffline(data) {
  return axios({
    url: `/api/oms/stageAddr/insert`,
    method: 'post',
    data
  })
}
// 门店地址修改
export function updateStageOffline(data) {
  return axios({
    url: `/api/oms/stageAddr/update`,
    method: 'post',
    data
  })
}
// get上传图片接口file
export function stageUploadFile(data) {
  return axios({
    url: `/api/oms/stageAddr/uploadFile`,
    method: 'get',
    params: data
  })
}
// post上传图片接口file
export function stageUploadFiles(data) {
  return axios({
    url: `/api/oms/stageAddr/uploadFile`,
    method: 'post',
    data
  })
}

// 司机授权门店
export function empowerDriverStage(ids, userId) {
  return axios({
    url: `/api/oms/stageAddr/empowerDriverStage?ids=${ids}&userId=${userId}`,
    method: 'get'
  })
}
// 司机查询授权门店
export function selectDriverStage(userId) {
  return axios({
    url: `/api/oms/stageAddr/selectDriverStage?userId=${userId}`,
    method: 'get'
  })
}
// 门店管理查询授权门店
export function selectManageStage(userId) {
  return axios({
    url: `/api/oms/stageAddr/selectManageStage?userId=${userId}`,
    method: 'get'
  })
}

// 门店授权渠道
export function selectChannelStage(ids, stageId) {
  return axios({
    url: `/api/oms/stageAddr/empowerStageChannel?ids=${ids}&stageId=${stageId}`,
    method: 'get'
  })
}
// 门店查询授权渠道
export function selectStageChannel(stageId) {
  return axios({
    url: `/api/oms/stageAddr/selectStageChannel?stageId=${stageId}`,
    method: 'get'
  })
}

// 生成带参数的门店二维码
export function getMinAppCode(data) {
  return axios({
    url: `/api/weChat/getMinAppGrCode`,
    method: 'post',
    data
  })
}

// 查询门店授权用户
export function getStageUser(stageId) {
  return axios({
    url: `/api/oms/stageAddr/stageUserList?stageId=${stageId}`,
    method: 'get'
  })
}

// 授权门店提现用户
export function getEmpowerCash(openId,stageId) {
  return axios({
    url: `/api/oms/stageAddr/empowerUserCashStage?openId=${openId}&stageId=${stageId}`,
    method: 'get'
  })
}
